<template>
  <client-only>
    <h3 class="text-center text-lg font-medium" :class="props.isNavbar ? 'mt-0' : 'mt-6'">{{ username }}</h3>
    <template #fallback>
      <n-skeleton class="w-20 h-6 rounded mx-auto" :class="props.isNavbar ? 'mt-0' : 'mt-6'" />
    </template>
  </client-only>
</template>

<script lang="ts" setup>
import { NSkeleton } from 'naive-ui'
import { useAuthStore } from '@/store/auth'

interface Props {
  isNavbar: boolean
}

const props = defineProps<Props>()

const { t } = useI18n()

const authStore = useAuthStore()
const { isLogin } = storeToRefs(authStore)

const username = computed(() => (isLogin.value ? authStore.username : t('member.guest')))
</script>
